<app-main>
  <h1>Correspondance</h1>
      <div style="margin-bottom: 16px; display: flex; justify-content: space-between;">
        <app-generic-create-button nameButton="correspondance" (click)="createButtonClicked()"></app-generic-create-button>
        <app-generic-search-label [listElements]="listCorrespondance" [tableConfig]="tableConfig" endPoint="correspondance"
        (queryEmit)="loadCorrespondances($event)"></app-generic-search-label>
    </div>
  <app-generic-table
    [config]="tableConfig"
    [rows]="listCorrespondance"
    [pageInformations]="pageInformations"
    (pageEmit)="pageEvent($event)"
    (updateEmit)="updateCorrespondance($event)"
    [updatebutton]="true"
    [isClickable]="true"
    [emitClickRow]="emitClickRow"
    [deletebutton]="true"
    (deleteEmit)="deleteCorrespondance($event)"
  ></app-generic-table>

</app-main>
  <ngx-spinner
    bdColor="rgba(0,0,0,0.8)"
    size="medium"
    color="#fff"
    type="ball-spin-clockwise"
    [fullScreen]="true"
  >
  </ngx-spinner>
